<app-breadcrumb [title]="title + ' Datos facturación'" [breadcrumb]="title + ' Datos facturación'"></app-breadcrumb>
<section class="login-page section-b-space">
    <div class="container">
        <div class="row">
            <form [formGroup]="facturacionForm" autocomplete="off">
                <div class="checkout-page">
                    <div class="checkout-form d-flex justify-content-center">
                        <div class="col-md-10">
                            <div class="row">
                                <!-- <div class="col-12 mb-3">
                                    <label for="rfc">Referencia de información:</label>
                                    <input  type="text" (input)="soloLetrasNumerosEspacios($event)" class="form-control text-uppercase"  formControlName="rfc" id="rfc" required="" maxlength="12" placeholder="Facturación Número 1">
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('rfc').touched) && facturacionForm.get('rfc').errors?.required">
                                        Campo requerido
                                    </span>
                                </div> -->
                                <div class="col-md-6 mb-3">
                                    <label for="rfc">Clave del Registro Federal de Contribuyentes (RFC)</label>
                                    <input  type="text" (input)="soloLetrasNumerosExt($event)" class="form-control text-uppercase"  formControlName="rfc" id="rfc" required="" maxlength="13" placeholder="Ingresa el RFC">
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('rfc').touched) && facturacionForm.get('rfc').errors?.required">
                                        Campo requerido
                                    </span>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('rfc').errors?.pattern)">
                                        El campo debe contener letras y números
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="nombre"> Nombre, denominación o razón social</label>
                                    <input type="text" formControlName="nombre" class="form-control" id="nombre" required>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('nombre').touched) && facturacionForm.get('nombre').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="d-flex justify-content-between">
                                        <label for="domicilioFiscal">Dirección</label>
                                        <a (click)="addDireccion()" class="newDirection">Agregar una Dirección</a>
                                    </div>

                                    <select formControlName="direccion" class="form-control" required>
                                    <option value="" *ngIf="showInfoDirec; else listDirec" selected>No
                                        hay direcciones registradas</option>
                                    <ng-template #listDirec>
                                        <option *ngFor="let d of listaDirecciones; index as i"
                                            [ngValue]="d">
                                            {{i+1}} - {{d.calle !=='' ? d.calle : 'Sin especificar'}},
                                            {{d.colonia !=='' ? d.colonia : 'Sin especificar'}},
                                            {{d.municipio !=='' ? d.municipio : 'Sin especificar'}},
                                            {{d.estado !=='' ? d.estado : 'Sin especificar'}}
                                            {{d.codigoPostal !=='' ? d.codigoPostal : 'Sin especificar'}}
                                        </option>
                                    </ng-template>
                                </select>                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('direccion').touched) && facturacionForm.get('direccion').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label for="domicilioFiscal">Correo Electrónico</label>
                                    <input type="text" formControlName="correo" class="form-control mb-0" id="domicilioFiscal" required>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('correo').touched) && facturacionForm.get('correo').errors?.required">
                                        Campo requerido o formato no válido
                                    </span>
                                </div>
                                <div class="col-md-12 mb-3">
                                    <label for="regimenFiscal">Régimen Fiscal</label>
                                    <select formControlName="regimenFiscal" class="form-control" id="usoCfdi"  (change)="changeRf()" required [compareWith]="compareRf">
                                        <option
                                        style="text-overflow: ellipsis !important"
                                         value="" selected [disabled]="true">Seleccione</option>
                                            <option *ngFor="let rf of listaRegimenFiscal; index as i" [ngValue]="rf" >
                                                {{rf.tipoPersonaDescripcion}} - {{rf.valor}} - {{rf.descripcion}}
                                            </option>
                                    </select>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('usoCfdi').touched) && facturacionForm.get('usoCfdi').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                                <div class="col-md-12 mb-5">
                                    <label id="usoCfdi">Uso CFDI</label>
                                    <select formControlName="usoCfdi" class="form-control" id="usoCfdi"  (change)="changeCdfi()" required>
                                        <option
                                        style="text-overflow: ellipsis !important"
                                         value="" selected [disabled]="true">Seleccione</option>
                                            <option *ngFor="let cfdi of listaCfdi; index as i" [ngValue]="cfdi" >
                                                {{cfdi.usoCFDI}} - {{cfdi.descripcion}}
                                            </option>
                                    </select>
                                    <span class="text-danger"
                                        *ngIf="(facturacionForm.get('usoCfdi').touched) && facturacionForm.get('usoCfdi').errors?.required">
                                        Campo requerido
                                    </span>
                                </div>
                            </div>
                            <div class=" d-flex gap-3 justify-content-end">
                                <button class="btn btn-solid mt-2 " (click)="volver()">Volver</button>
                                <button class="btn btn-solid mt-2 " (click)="guardar()">Guardar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div *ngIf="modalSwitch === true">
        <app-modal-direccion></app-modal-direccion>
    </div>
</section>